module.exports = __webpack_public_path__ + "static/media/COS_PRESENTATION_FRANCE.759739b3.png";